import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import colorStyle from './colorChoice.module.scss';

function ColorChoice(props) {
  const {
    colors, width, itemWidth, onChange, clearAll, colorNameSize, unit, defaultColors, disableColorList,
  } = props;
  const [checkedList, setCheckedList] = useState([]);
  useEffect(() => {
    if (clearAll) {
      setCheckedList([]);
    }
    if (defaultColors) {
      setCheckedList(defaultColors);
    }
  }, [clearAll, defaultColors]);

  const onClickItem = (item, isClick) => {
    if (!isClick) return;
    const index = checkedList.indexOf(item);
    if (index > -1) {
      checkedList.splice(index, 1);
      onChange([...checkedList]);
      setCheckedList([...checkedList]);
    } else {
      onChange([...checkedList, item]);
      setCheckedList([...checkedList, item]);
    }
  };
  const lightColors = ['#FFF', '#FFFFFF', '#F1F1D7', 'white'];
  const isLightColor = (color) => lightColors.includes(color.toUpperCase());
  return (
    <div className={colorStyle['colors-choice']} style={{ width: `${width}${unit}` }}>
      {
        colors.map((item) => (
          <div
            className={`${colorStyle['colors-item']} 
            ${disableColorList.length
              ? disableColorList.includes(item.colorCode) && colorStyle['colors-item-disable'] : ''}`}
            key={item.id}
            role="none"
            onClick={
              () => onClickItem(item.name, disableColorList.length ? !disableColorList.includes(item.colorCode) : true)
            }
            id={`colors-${item.colorHex}`}
          >
            <div className={`${colorStyle['colors-mask']}`} />
            <span
              aria-hidden
              className={`
              ${colorStyle['colors-item-radius']} ${isLightColor(item.colorHex) ? colorStyle['light-color'] : ''}`}
              style={{
                backgroundColor: `${item.colorHex}`,
                width: `${itemWidth}${unit}`,
                height: `${itemWidth}${unit}`,
                marginBottom: '10px',
              }}
            >
              {checkedList.includes(item.name)
                ? (
                  <>
                    <span
                      className={colorStyle['white-check']}
                      style={{ display: isLightColor(item.colorHex) ? 'none' : '' }}
                    />
                    <span
                      className={colorStyle['black-check']}
                      style={{ display: isLightColor(item.colorHex) ? '' : 'none' }}
                    />
                  </>
                ) : null}
            </span>
            <span className={colorStyle['color-name']} style={{ fontSize: colorNameSize }}>{item.name}</span>
          </div>
        ))
      }
    </div>
  );
}

ColorChoice.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.object).isRequired,
  width: PropTypes.string.isRequired,
  itemWidth: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  clearAll: PropTypes.bool.isRequired,
  colorNameSize: PropTypes.string,
  unit: PropTypes.string,
  disableColorList: PropTypes.arrayOf(PropTypes.string),
  defaultColors: PropTypes.arrayOf(PropTypes.string),
};

ColorChoice.defaultProps = {
  colorNameSize: '14px',
  unit: 'px',
  defaultColors: [],
  disableColorList: [],
};

export default ColorChoice;
